const appSidebar = {
    positions: {
        // ======================[ HANDEL ]
        ROUTE_TRADE_DASHBOARD: 'Panel handlu',
        ROUTE_TRADE_DASHBOARD_GENERAL: 'Konsola',
        ROUTE_TRADE_DASHBOARD_ORDERS: 'Lista zamówień',
        ROUTE_TRADE_DASHBOARD_STATS: 'Statistics',
        ROUTE_TRADE_DASHBOARD_PARCELS: 'Parcel Manager',

        ROUTE_TRADE_EVENTS: 'Events',
        ROUTE_TRADE_EVENTS_OPINIONS: 'Opinions',
        ROUTE_TRADE_EVENTS_NOTIFICATIONS: 'System Notifications',

        ROUTE_TRADE_ACTIONS: 'Actions',
        ROUTE_TRADE_ACTIONS_DISCOUNTS: 'Discount Coupons',
        ROUTE_TRADE_ACTIONS_DISCOUNTS_EDIT: 'Edit',
        ROUTE_TRADE_ACTIONS_ADBANNERS: 'Article Card Ads',
        ROUTE_TRADE_ACTIONS_ADBANNERS_EDIT: 'Edit',
        ROUTE_TRADE_ACTIONS_TECHNICAL_BREAK: 'Technical Break',

        // ======================[ ARTYKUŁY I ZAMÓWIENIA ]
        ROUTE_SYNCHRONIZATIONS: 'Synchronizacja z ERP',

        ROUTE_PRODUCTS_DESCRIPTIONS_IMPORT: 'Import Article Descriptions',

        ROUTE_ASSORTMENT: 'Assortment',
        ROUTE_ASSORTMENT_CATEGORIES: 'Categories',
        ROUTE_ASSORTMENT_CATEGORIES_EDIT: 'Edit',
        ROUTE_ASSORTMENT_PRODUCTS: 'Product List and Settings',
        ROUTE_ASSORTMENT_PRODUCTS_EDIT: 'Edit',
        ROUTE_ASSORTMENT_PRODUCTS_CATEGORY_ASSIGN: 'Assign Products to Categories',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_TILE: 'Tile Settings',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_LIST: 'List Settings',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_CARD: 'Article Card Settings',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_CARD_SECTIONS: 'Article Card Sections',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_CARD_SECTIONS_EDIT: 'Edit',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_GENERAL: 'Presentation',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_COMPARISON: 'Comparison',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_QUANTITY: 'Stock Levels',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_UNITS: 'Units of Measure',
        ROUTE_ASSORTMENT_PRODUCT_PRESENTATION_DELIVERY: 'Delivery',
        ROUTE_ASSORTMENT_SHIPMENT_SERVICES: 'Shipping Services',
        ROUTE_ASSORTMENT_PAYMENT_SERVICES: 'Payment Services',
        ROUTE_ASSORTMENT_OTHER_SERVICES: 'Other Services',
        ROUTE_ASSORTMENT_SEARCH_ENGINE: 'Search Engine and Filters',
        ROUTE_ASSORTMENT_MANUFACTURERS: 'Manufacturers',
        ROUTE_ASSORTMENT_MANUFACTURERS_EDIT: 'Edit',
        ROUTE_ASSORTMENT_ATTRIBUTES: 'Attributes',
        ROUTE_ASSORTMENT_ATTRIBUTES_EDIT: 'Edit',
        ROUTE_ASSORTMENT_FEATURES: 'Features',
        ROUTE_ASSORTMENT_FEATURES_EDIT: 'Edit',

        ROUTE_ORDERS: 'Orders',
        ROUTE_ORDERS_GENERAL: '>>>Order Parameters<<<',
        ROUTE_ORDERS_SHIPPING_AND_PAYMENT_GENERAL: 'Shipping and Payment Form Parameters',
        ROUTE_ORDERS_SHIPPING_METHODS: 'Shipping Methods',
        ROUTE_ORDERS_PAYMENT_METHODS: 'Payment Methods',
        ROUTE_ORDERS_STATUSES: 'Order Statuses',
        ROUTE_ORDERS_GREETINGS: 'Thank You Messages',
        ROUTE_ORDERS_NOTIFYCATIONS: '>>>Notifications<<<',
        ROUTE_ORDERS_CART: '>>>Cart<<<',
        ROUTE_ORDERS_EDIT: 'Edit',
        ROUTE_ORDERS_DETAILS: 'Details',

        // ======================[ MENU ]
        ROUTE_MENU: 'Menu',
        ROUTE_MENU_POSITIONS: 'Menu Positions',
        ROUTE_MENU_POSITIONS_EDIT: 'Edit',
        ROUTE_MENU_CUSTOM_PAGES: 'Custom Pages',
        ROUTE_MENU_CUSTOM_PAGES_EDIT: 'Edit',
        ROUTE_MENU_POPUPS: 'Popup Windows',
        ROUTE_MENU_POPUPS_EDIT: 'Edit',
        ROUTE_MENU_PREDEFINED_SEARCH: 'Predefined Article Filtering',
        ROUTE_MENU_PREDEFINED_SEARCH_EDIT: 'Edit',
        ROUTE_MENU_SECTIONS: '>>>Sections<<<',
        ROUTE_MENU_FOOTER: 'Footer',

        // ======================[ GRAFIKA ]
        ROUTE_GRAPHICS_SETTINGS: 'Settings',
        ROUTE_GRAPHICS_SETTINGS_MEDIA_LIBRARY: 'Media Library',
        ROUTE_GRAPHICS_SETTINGS_LAYOUT: 'Layout',
        ROUTE_GRAPHICS_SETTINGS_LAYOUT_EDIT: 'Edit',
        ROUTE_GRAPHICS_SETTINGS_LOGO: 'Logo',
        ROUTE_GRAPHICS_SETTINGS_PROMOTIONBAR: 'Promotion Bar',
        ROUTE_GRAPHICS_SETTINGS_PLACEHOLDER_IMAGES: 'Placeholder Images',
        ROUTE_GRAPHICS_SETTINGS_BUTTONS: 'Button Definitions',
        ROUTE_GRAPHICS_SETTINGS_BUTTONS_EDIT: 'Edit',
        ROUTE_GRAPHICS_SETTINGS_IMAGE_QUALITY: 'Image Quality',
        ROUTE_GRAPHICS_SETTINGS_FONTS: 'Fonts',
        ROUTE_GRAPHICS_MAIN_PAGE: 'Main Page',
        ROUTE_GRAPHICS_MAIN_PAGE_EDIT: 'Edit',
        ROUTE_GRAPHICS_MAIN_PAGE_GENERAL: 'General',
        ROUTE_GRAPHICS_MAIN_PAGE_SECTIONS: 'Sections',
        ROUTE_GRAPHICS_MAIN_PAGE_METATAGS: 'Meta Tags',

        ROUTE_GRAPHICS_REGISTRATION_PAGE: 'User Registration',
        ROUTE_GRAPHICS_REGISTRATION_SUMMARY_PAGE_SECTIONS: 'Summary',
        ROUTE_GRAPHICS_REGISTRATION_SUMMARY_PAGE_EDIT: 'Edit',
        ROUTE_GRAPHICS_REGISTRATION_CONFIRMATION_PAGE_SECTIONS: 'Information After Email Confirmation',
        ROUTE_GRAPHICS_REGISTRATION_CONFIRMATION_PAGE_EDIT: 'Edit',

        ROUTE_GRAPHICS_CART_PAGE: 'Cart',
        ROUTE_GRAPHICS_CART_PAGE_SECTIONS: 'Sections',
        ROUTE_GRAPHICS_CART_PAGE_EDIT: 'Edit',

        // ======================[ KOMUNIKACJA ]
        ROUTE_COMMUNICATION_EMAIL: 'E-mail',
        ROUTE_COMMUNICATION_EMAIL_SERVER: 'Email Servers',
        ROUTE_COMMUNICATION_EMAIL_SERVER_EDIT: 'Edit',
        ROUTE_COMMUNICATION_EMAIL_TEMPLATES: 'Email Templates',
        ROUTE_COMMUNICATION_EMAIL_TABLE_DEFINITIONS: 'Tables',
        ROUTE_COMMUNICATION_EMAIL_TABLE_DEFINITION: 'Table Layout Definition',
        ROUTE_COMMUNICATION_SMS: 'SMS',
        ROUTE_COMMUNICATION_SMS_GATE: 'SMS Gateway',
        ROUTE_COMMUNICATION_SMS_TEMPLATES: 'SMS Templates',

        // ======================[ RODO ]
        ROUTE_RODO_AGREEMENTS: 'Agreements - Definitions',
        ROUTE_RODO_AGREEMENTS_EDIT: 'Edit',
        ROUTE_RODO_AGREEMENTS_REGISTRY: 'Consent Registry',
        ROUTE_RODO_COOKIES_AGREEMENTS: 'Cookies',
        ROUTE_RODO_COOKIES_AGREEMENTS_EDIT: 'Edit',

        // ======================[ JĘZYKI I KRAJE ]
        ROUTE_LANGUAGES_AND_COUNTRIES_LANGUAGES: 'Języki sklepu',
        ROUTE_LANGUAGES_AND_COUNTRIES_COUNTRIES: 'Lista państw',
        ROUTE_LANGUAGES_AND_COUNTRIES_CURRENCIES: 'Currencies',
        ROUTE_LANGUAGES_AND_COUNTRIES_CURRENCIES_EDIT: 'Edit',
        ROUTE_LANGUAGES_AND_COUNTRIES_EXCHANGERATES: 'Exchange Rates',
        ROUTE_LANGUAGES_AND_COUNTRIES_EXCHANGERATES_EDIT: 'Edit',
        ROUTE_LANGUAGES_AND_COUNTRIES_REGIONS: 'Regions',
        ROUTE_LANGUAGES_AND_COUNTRIES_REGIONS_EDIT: 'Edit',
        ROUTE_LANGUAGES_AND_COUNTRIES_TRANSLATIONS: 'Translations',

        // ======================[ INTEGRACJE ]
        ROUTE_INTEGRATIONS: 'Integrations',
        ROUTE_INTEGRATIONS_ONLINE_PAYMENTS: 'Online Payments',
        ROUTE_INTEGRATIONS_ONLINE_PAYMENTS_P24: 'Przelewy24',
        ROUTE_INTEGRATIONS_ONLINE_PAYMENTS_PAYU: 'PayU',
        ROUTE_INTEGRATIONS_COURIERS: 'Couriers',
        ROUTE_INTEGRATIONS_COURIERS_INPOST: 'InPost Paczkomaty',
		ROUTE_INTEGRATIONS_COURIERS_APACZKA: 'APaczka',
		ROUTE_INTEGRATIONS_COURIERS_FURGONETKA: 'Furgonetka',
        ROUTE_INTEGRATIONS_SOCIAL: 'Social',
        ROUTE_INTEGRATIONS_SOCIAL_FACEBOOK: 'Facebook Pixel',
        ROUTE_INTEGRATIONS_COMPARISIONS: 'Comparisons',
        ROUTE_INTEGRATIONS_COMPARISIONS_CENEO: 'Ceneo',
        ROUTE_INTEGRATIONS_COMPARISIONS_GOOGLE: 'Google Merchant',
        ROUTE_INTEGRATIONS_MARKETING: 'Marketing',
        ROUTE_INTEGRATIONS_MARKETING_GOOGLE: 'Google Analytics',
        ROUTE_INTEGRATIONS_MARKETING_SALES_MENAGO: 'SALESmenago',
        ROUTE_INTEGRATIONS_MARKETING_FRESHMAIL: 'Freshmail',
        ROUTE_INTEGRATIONS_MARKETING_INSPECTLET: 'Inspectlet',
        ROUTE_INTEGRATIONS_REVIEWS: 'Opinie',
        ROUTE_INTEGRATIONS_REVIEWS_GOOGLE: 'Google',
        ROUTE_INTEGRATIONS_REVIEWS_OPINEO: 'Opineo',
        ROUTE_INTEGRATIONS_COMMUNICATION: 'Communication Channels',
        ROUTE_INTEGRATIONS_COMMUNICATION_CHAT: 'Chat',
        ROUTE_INTEGRATIONS_COMMUNICATION_SMS: 'SMS Server',
        ROUTE_INTEGRATIONS_OTHER: 'Other',
        ROUTE_INTEGRATIONS_OTHER_RECAPTCHA: 'reCaptcha',
        ROUTE_INTEGRATIONS_OTHER_GOOGLE_SEARCH_CONSOLE: 'Google Search Console',
        ROUTE_INTEGRATIONS_OTHER_COOKIEBOT: 'Cookiebot',

        // ======================[ SEO ]
        ROUTE_SEO_SITEMAP: 'Google Sitemap',
        ROUTE_SEO_IMAGES: 'Images',
        ROUTE_SEO_ADWORDS: '>>>Google AdWords<<<',
        ROUTE_SEO_METATAGS: 'Meta Tags',
        ROUTE_SEO_METATAGS_CART: 'Cart',
        ROUTE_SEO_METATAGS_ORDER_AUTHORIZE: 'Order - Login',
        ROUTE_SEO_METATAGS_ORDER_GUEST: 'Zamówienie - gość',
        ROUTE_SEO_METATAGS_ORDER_SHIPMENT: 'Zamówienie - dostawa',
        ROUTE_SEO_METATAGS_ORDER_PAYMENT: 'Zamówienie - płatność',
        ROUTE_SEO_METATAGS_ORDER_SUMMARY: 'Zamówienie - podsumowanie',
        ROUTE_SEO_METATAGS_ORDER_GREETINGS: 'Zamówienie - podziękowanie',
        ROUTE_SEO_METATAGS_ORDER_INACTIVE: 'Zamówienie nieaktywne',
        ROUTE_SEO_METATAGS_FAVOURITES: 'Ulubione',
        ROUTE_SEO_METATAGS_404: '404',
        ROUTE_SEO_METATAGS_REGISTRATION: 'Rejestracja',
        ROUTE_SEO_METATAGS_LOGIN: 'Strona logowania',
        ROUTE_SEO_METATAGS_PASSWORD_RECOVERY: 'Odzyskiwanie hasła',
        ROUTE_SEO_METATAGS_PASSWORD_SET_NEW_PASSWORD: 'Ustawianie nowego hasła',
        ROUTE_SEO_METATAGS_COMPARISION: 'Porównanie',
        ROUTE_SEO_METATAGS_CONTACT: 'Kontakt',
        ROUTE_SEO_METATAGS_USERPROFILE_ACCOUNT: 'Profil - konto',
        ROUTE_SEO_METATAGS_USERPROFILE_BASIC: 'Profil - podstawowe',
        ROUTE_SEO_METATAGS_USERPROFILE_ADDRESSBOOK: 'Profil - adresy',
        ROUTE_SEO_METATAGS_USERPROFILE_ORDERS: 'Profil - zamówienia',
        ROUTE_SEO_METATAGS_USERPROFILE_SETTINGS: 'Profil - ustawienia',
        ROUTE_SEO_METATAGS_GLOBAL_SEARCH: 'Wyszukiwanie globalne',
        ROUTE_SEO_OWNCODE: 'Własny kod',

        // ======================[ USTAWIENIA GLOBALNE ]
        ROUTE_GLOBAL_SETTINGS_CATALOGUE_MODE: 'Tryb katalogu',
        ROUTE_GLOBAL_SETTINGS_404: 'Strona 404',
        ROUTE_GLOBAL_SETTINGS_TAX_RATES: 'Stawki VAT',
        ROUTE_GLOBAL_SETTINGS_LOGIN: 'Logowanie i rejestracja',
        ROUTE_GLOBAL_SETTINGS_USERS: 'Users and Contractors',
        ROUTE_GLOBAL_SETTINGS_USERS_ACCOUNTS: 'User Accounts',
        ROUTE_GLOBAL_SETTINGS_USERS_ROLES: 'Roles',
        ROUTE_GLOBAL_SETTINGS_USERS_ROLE_EDIT: 'Edit Role',

        // ======================[ UŻYTKOWNICY PANELU ]
        ROUTE_PANEL_USERS_ACCOUNT_SETTINGS: 'Ustawienia konta',
        ROUTE_PANEL_USERS_ADMIN: '>>>Admin<<<',
        ROUTE_PANEL_USERS_LIST: '>>>Lista użytkowników<<<',
        ROUTE_PANEL_USERS_EDIT: 'Edycja użytkownika',

        // ======================[ DODATKOWE ]
        ROUTE_EXTRAS: 'Dodatkowe',
        ROUTE_EXTRAS_GENERAL: 'Ogólne',
        ROUTE_EXTRAS_CATEGORIES: 'Kategorie',
    },
    sections: {
        trade: 'HANDEL',
        articlesAndOrders: 'ARTYKUŁY I ZAMÓWIENIA',
        menu: 'MENU',
        graphics: 'GRAFIKA',
        communication: 'KOMUNIKACJA',
        rodo: 'RODO',
        languagesAndCountries: 'JĘZYKI I KRAJE',
        integrations: 'INTEGRACJE',
        seo: 'SEO',
        globalSettings: 'USTAWIENIA GLOBALNE',
        panelUsers: 'UŻYTKOWNICY PANELU',
        extras: 'DODATKOWE'
    }
};

export default appSidebar;